import React from 'react';

const UnitInput = ({ 
  value, 
  onChange, 
  min = 1, 
  className = "", 
  placeholder = "Enter units",
  disabled = false,
  autoComplete = 'off'
}) => {
  const handleChange = (e) => {
    const inputValue = e.target.value;
    
    // Allow empty string for better UX during editing
    if (inputValue === '') {
      onChange('');
      return;
    }
    
    // Only allow digits
    if (!/^\d+$/.test(inputValue)) {
      return;
    }
    
    let newValue = parseInt(inputValue) || '';
    
    // Clean numbers starting with 0 (e.g., 01 -> 1, 001 -> 1)
    if (inputValue.startsWith('0') && inputValue.length > 1) {
      newValue = parseInt(inputValue.replace(/^0+/, ''));
    }
    
    // Ensure minimum value if not empty
    if (newValue !== '' && newValue < min) {
      newValue = min;
    }
    
    onChange(newValue);
  };

  const handleBlur = (e) => {
    // On blur, validate and clean the value
    const inputValue = e.target.value;
    
    if (inputValue === '') {
      // Keep empty if user wants it empty (validation will catch this)
      onChange('');
      return;
    }
    
    // Clean the value when clicking away - ensure it's a clean integer
    const cleanValue = parseInt(inputValue) || min;
    const finalValue = cleanValue < min ? min : cleanValue;
    onChange(finalValue);
  };

  return (
    <input
      type="text"
      inputMode="numeric"
      pattern="[0-9]*"
      value={value}
      onChange={handleChange}
      onBlur={handleBlur}
      disabled={disabled}
      placeholder={placeholder}
      className={`px-0 py-0 text-sm border border-gray-200 focus:border-green-400 focus:ring-1 focus:ring-green-400 focus:outline-none text-gray-900 h-8 bg-gray-50 ${className}`}
      autoComplete={autoComplete}
    />
  );
};

export default UnitInput;
